import React, { useEffect, useState } from "react";
import { BoutonParametres } from "../components/Parametres";

const shortcuts = [
  { icon: "bi-file-earmark-plus", label: "Nouvelle épreuve", action: "new-exam" },
  { icon: "bi-folder2-open", label: "Mes épreuves", action: "exams" },
  { icon: "bi-pencil-square", label: "Brouillons", action: "drafts" },
  { icon: "bi-clock-history", label: "Historique", action: "history" },
  { icon: "bi-cloud-check", label: "Hors connexion", action: "hors-connexion" },
  { icon: "bi-building", label: "Établissements", action: "establishments" },
  { icon: "bi-mortarboard", label: "Profil soutien", action: "soutien" },
  { icon: "bi-chat-dots", label: "Messagerie", action: "messages" },
  { icon: "bi-bell", label: "Notifications", action: "notifications" },
  { icon: "bi-wallet2", label: "Portefeuille", action: "wallet" },
  { icon: "bi-person-circle", label: "Compte", action: "account" },
];

const sidebarItems = [
  { icon: "bi-grid-1x2-fill", label: "Tableau de bord", action: "dashboard" },
  { icon: "bi-plus-lg", label: "Nouvelle épreuve", action: "new-exam", badge: "Nouveau" },
  { icon: "bi-file-earmark-text", label: "Mes épreuves", action: "exams" },
  { icon: "bi-pencil-square", label: "Brouillons", action: "drafts" },
  { icon: "bi-clock-history", label: "Historique", action: "history" },
  { icon: "bi-cloud-check", label: "Hors connexion", action: "hors-connexion" },
  { icon: "bi-building", label: "Établissements", action: "establishments" },
  { icon: "bi-journal-check", label: "Fiches TD", action: "td" },
  { icon: "bi-mortarboard", label: "Profil soutien", action: "soutien" },
  { icon: "bi-chat-dots", label: "Messagerie", action: "messages" },
  { icon: "bi-bell", label: "Notifications", action: "notifications" },
  { icon: "bi-wallet2", label: "Portefeuille", action: "wallet" },
];

export default function TeacherDashboard({ data, onLogout, onStartExam, onNavigate }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const subjects = Array.isArray(data.matieres) ? data.matieres : [];
  const stats = data.statistics || {};
  const unread = data.unread || {};

  useEffect(() => {
    if (!sidebarOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const closeOnEscape = (event) => { if (event.key === "Escape") setSidebarOpen(false); };
    window.addEventListener("keydown", closeOnEscape);
    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [sidebarOpen]);

  const activate = (action) => {
    setSidebarOpen(false);
    return action === "new-exam" ? onStartExam() : onNavigate(action);
  };

  return (
    <main className="ql-teacher-dashboard-shell">
      <button type="button" className="ql-dashboard-menu-toggle" onClick={() => setSidebarOpen(true)} aria-label="Ouvrir le menu enseignant" aria-expanded={sidebarOpen}>
        <i className="bi bi-list" aria-hidden="true" /><span>Menu</span>
      </button>
      {sidebarOpen && <button type="button" className="ql-dashboard-sidebar-overlay" onClick={() => setSidebarOpen(false)} aria-label="Fermer le menu enseignant" />}
      <aside className={`ql-dashboard-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="ql-dashboard-brand">
          <img src="/static/logo.png" alt="Quick Learning" />
          <div><strong>Quick Learning</strong><span>Espace enseignant</span></div>
          <button type="button" className="ql-dashboard-sidebar-close" onClick={() => setSidebarOpen(false)} aria-label="Fermer le menu"><i className="bi bi-x-lg" /></button>
        </div>
        <div className="ql-dashboard-nav-section">PRINCIPAL</div>
        <nav aria-label="Navigation du tableau de bord">
          {sidebarItems.map((item) => <button type="button" className={item.action === "dashboard" ? "active" : ""} key={item.action} onClick={() => activate(item.action)}>
            <i className={`bi ${item.icon}`} aria-hidden="true" /><span>{item.label}</span>{item.badge && <em>{item.badge}</em>}
          </button>)}
        </nav>
        <div className="ql-dashboard-nav-section">COMPTE</div>
        <nav aria-label="Compte enseignant">
          <button type="button" onClick={() => onNavigate("account")}><i className="bi bi-person-circle" /><span>Compte</span></button>
          <BoutonParametres avecTexte />
          <button type="button" className="logout" onClick={() => { setSidebarOpen(false); onLogout(); }}><i className="bi bi-box-arrow-right" /><span>Déconnexion</span></button>
        </nav>
        <div className="ql-dashboard-wallet-card">
          <span>MON PORTEFEUILLE</span>
          <strong>{data.wallet?.balance ?? 0} <small>{data.wallet?.currency || "FCFA"}</small></strong>
          <button type="button" onClick={() => onNavigate("wallet")}>Gérer le portefeuille</button>
        </div>
      </aside>

      <div className="ql-teacher-dashboard-content">
      <section className="ql-dashboard-welcome">
        <div>
          <span className="ql-teacher-eyebrow">TABLEAU DE BORD</span>
          <h1>Bonjour, {data.identity?.nom_complet || data.identity?.username}</h1>
          <p>Voici un aperçu de votre espace enseignant.</p>
        </div>
        <span className="ql-teacher-status">
          <i className="bi bi-patch-check-fill" aria-hidden="true"></i>
          Générateur autorisé
        </span>
      </section>

      <section className="ql-dashboard-stats" aria-label="Résumé du compte">
        <article><i className="bi bi-file-earmark-text"></i><div><span>Épreuves</span><strong>{stats.epreuves || 0}</strong><small>Total</small></div></article>
        <article><i className="bi bi-pencil-square"></i><div><span>Brouillons</span><strong>{stats.brouillons || 0}</strong><small>Total</small></div></article>
        <article><i className="bi bi-building"></i><div><span>Établissements</span><strong>{stats.etablissements || 0}</strong><small>Total</small></div></article>
        <article><i className="bi bi-wallet2"></i><div><span>Portefeuille</span><strong>{data.wallet?.balance ?? 0}</strong><small>{data.wallet?.currency || "FCFA"}</small></div></article>
        <article><i className="bi bi-bell"></i><div><span>Notifications</span><strong>{unread.notifications || 0}</strong><small>Non lues</small></div></article>
        <article><i className="bi bi-chat-dots"></i><div><span>Messages</span><strong>{unread.messages || 0}</strong><small>Non lus</small></div></article>
      </section>

      <section className="ql-teacher-panel">
        <div className="ql-teacher-panel-title">
          <div>
            <span className="ql-teacher-eyebrow">Profil pédagogique</span>
            <h2>Matières enseignées</h2>
          </div>
          <span className="ql-teacher-code">{data.code_enseignant}</span>
        </div>
        <div className="ql-teacher-subjects">
          {subjects.length
            ? subjects.map((subject) => <span key={subject.id}>{subject.name}</span>)
            : <p>Aucune matière n’est encore associée à ce compte.</p>}
        </div>
      </section>

      <section className="ql-teacher-panel">
        <div className="ql-teacher-panel-title">
          <div>
            <span className="ql-teacher-eyebrow">Accès rapide</span>
            <h2>Continuer dans l’espace enseignant</h2>
          </div>
          <small>Sélectionnez une action pour continuer.</small>
        </div>
        <div className="ql-teacher-shortcuts">
          {shortcuts.map((shortcut) => (
            <button
              type="button"
              key={shortcut.label}
              onClick={shortcut.action === "new-exam" ? onStartExam : () => onNavigate(shortcut.action)}
            >
              <i className={`bi ${shortcut.icon}`} aria-hidden="true"></i>
              <span>{shortcut.label}</span>
              <i className="bi bi-arrow-up-right" aria-hidden="true"></i>
            </button>
          ))}
        </div>
      </section>
      <footer className="ql-dashboard-footer">Quick Learning — Espace enseignant</footer>
      </div>
    </main>
  );
}
